import { fetchGlobalStylesFields, fetchGlobalStylesObject, fetchThemePreset } from 'ContentData/api/GlobalStyles';
import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { GLOBAL_STYLES_FETCH } from 'ContentData/actions/ActionTypes';
import { mergeDeep } from 'ContentUtils/helpers/ObjectHelpers';
const fetchGlobalStylesAction = createGenericFetchAction(GLOBAL_STYLES_FETCH, async (__options = {}, httpClient) => {
  // Fetch fields and the GS object (overrides + themeId) in parallel
  const [fields, {
    themeId,
    overrides
  }] = await Promise.all([fetchGlobalStylesFields(httpClient), fetchGlobalStylesObject(httpClient)]);

  // If no theme is active, user overrides are the only source of truth
  if (!themeId) {
    return {
      fields,
      overrides
    };
  }

  // Fetch the active theme and deep merge its base styles with user overrides
  const presetStyles = await fetchThemePreset(themeId, httpClient);
  return {
    fields,
    overrides: mergeDeep(presetStyles, overrides)
  };
});
export const fetchGlobalStyles = (options = {}) => fetchGlobalStylesAction(options);